import {
  AbsoluteFill,
  interpolate,
  OffthreadVideo,
  Sequence,
  staticFile,
  useCurrentFrame,
} from "remotion";
import { z } from "zod";
import { AnimatedTDCEuFuiCard } from "./AnimatedTDCEuFuiCard";
import { CARD_DURATION_FRAMES, CARD_EXIT_FRAME, ELEMENTS_IN_FRAME, FPS } from "../../lib/types";

const OVERLAY_FADE_START = Math.round(2.8 * FPS);
const OVERLAY_FADE_END = ELEMENTS_IN_FRAME;
const DUOTONE_MAX_OPACITY = 0.82;
const EU_FUI_TINT = "#004c94";

export const tdcEuFuiVideoSchema = z.object({
  photoUrl: z.string(),
  photoOffsetX: z.number().optional().default(0),
  photoOffsetY: z.number().optional().default(0),
  photoScale: z.number().optional().default(1),
  editionSlug: z.string(),
  editionNameLine1: z.string().optional().default("TDC Floripa 2026"),
  editionNameLine2: z.string().optional().default("#EuFui"),
  showSafeArea: z.boolean().optional().default(false),
});

export type TDCEuFuiVideoProps = z.infer<typeof tdcEuFuiVideoSchema>;

export const TDCEuFuiVideo: React.FC<TDCEuFuiVideoProps> = (props) => {
  const frame = useCurrentFrame();
  const overlayOpacity = interpolate(frame, [OVERLAY_FADE_START, OVERLAY_FADE_END], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  return (
    <AbsoluteFill style={{ backgroundColor: "black" }}>
      <OffthreadVideo
        src={staticFile("/tdc-video-background.mp4")}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
      <AbsoluteFill
        style={{
          backgroundColor: EU_FUI_TINT,
          mixBlendMode: "multiply",
          opacity: DUOTONE_MAX_OPACITY * overlayOpacity,
        }}
      />
      <AbsoluteFill
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(0,0,0,0) 40%, rgba(0,0,0,0.55) 100%)",
          pointerEvents: "none",
          opacity: overlayOpacity,
        }}
      />
      <Sequence from={ELEMENTS_IN_FRAME} durationInFrames={CARD_DURATION_FRAMES}>
        <AnimatedTDCEuFuiCard {...props} exitStartFrame={CARD_EXIT_FRAME} />
      </Sequence>
    </AbsoluteFill>
  );
};
